import {initState} from "../contexts/initState";

export const setLocalStorage = async (value) => {
    const currentState = await getLocalStorage();
    const newState = {
        ...currentState,
        ...value,
    };
    localStorage.setItem(`rpa_state`, JSON.stringify(newState));
    return await getLocalStorage();
};

export const setLocalStorageNode = async (node, value) => {
    const currentState = await getLocalStorage();
    const newState = node !== "" ? {
        ...currentState,
        [node]: {
            ...currentState[node],
            ...value,
        },
    } : {
        ...currentState,
        ...value,
    };
    localStorage.setItem(`rpa_state`, JSON.stringify(newState));
    return await getLocalStorage();
};

export const getLocalStorage = async () => {
    const data = localStorage.getItem(`rpa_state`);

    if (data === null)
        localStorage.setItem(`rpa_state`, '{}');

    return JSON.parse(data);
};

export const updateState = async () => {
    localStorage.setItem(`rpa_state`, JSON.stringify(initState));
};
